var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, Form, Row } from "@brushfire/ui";
import { useContext, useEffect, useState } from "react";
import Constants from "../../../data/constants";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { getAttendeeCommunities, putAttendeeCommunity } from "../../../data/api";
import { useDispatch } from "react-redux";
import { handleErrors } from "../../../data/helpers";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { AppFormContext } from "../../../App";
import WidgetSticky from "../../Helpers/WidgetSticky";
import Skeleton from "@material-ui/lab/Skeleton";
import * as Yup from "yup";
import NoChangesAfterMessage from "./NoChangesAfterMessage";
var MyAttendeeCommunity = function (_a) {
    var eventData = _a.eventData, attendee = _a.attendee, path = _a.path, setConfirmationMessage = _a.setConfirmationMessage, refreshAttendeeList = _a.refreshAttendeeList, order = _a.order, group = _a.group;
    var _b = __read(useState(), 2), communityData = _b[0], setCommunityData = _b[1];
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var formikContext = useContext(AppFormContext).formikContext;
    useEffect(function () {
        if ([Constants.Routes.myAttendeeCommunity].includes(path)) {
            getAttendeeCommunities(attendee.id)
                .then(function (_a) {
                var data = _a.data;
                setCommunityData(data);
            })
                .catch(function (err) {
                handleErrors(err, dispatch, formikContext);
            });
        }
    }, [path]);
    var onSubmit = function (values, formikHelpers, setGlobalError) {
        putAttendeeCommunity(attendee.id, values)
            .then(function (_a) {
            var _b, _c;
            var data = _a.data;
            if (data) {
                refreshAttendeeList();
                var newCommunity = communityData === null || communityData === void 0 ? void 0 : communityData.communities.find(function (g) { return g.id === values.communityId; });
                formikHelpers.setSubmitting(false);
                setConfirmationMessage({
                    title: "You're all set!",
                    subtitle: "You have joined ".concat(newCommunity ? newCommunity.name : "a new community"),
                });
                history.push(Constants.Routes.myAttendee
                    .replace(":clientKey", eventData.clientKey)
                    .replace(":urlKey", eventData.urlKey)
                    .replace(Constants.Regex.guid, "")
                    .replace(":attendeeId", attendee.id)
                    .replace(":orderId", (_b = order === null || order === void 0 ? void 0 : order.id) !== null && _b !== void 0 ? _b : "")
                    .replace(":groupId", (_c = group === null || group === void 0 ? void 0 : group.id) !== null && _c !== void 0 ? _c : "")
                    .replace(":eventNumber", eventData.eventNumber.toString()));
            }
        })
            .catch(function (err) {
            handleErrors(err, dispatch, formikContext, setGlobalError);
        })
            .finally(function () {
            formikHelpers.setSubmitting(false);
        });
    };
    if (!communityData) {
        return (_jsx(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: true }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }) })));
    }
    var communitySchema = Yup.object().shape({
        communityId: Yup.string().required("Community is required"),
    });
    return (_jsxs(_Fragment, { children: [_jsx(NoChangesAfterMessage, { changesAreBlocked: communityData.changesAreBlocked, changesAreBlockedAfter: communityData.changesAreBlockedAfter }), _jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, formikBagProps: {
                    submitButtonLabel: "Change Community",
                    hideButton: (attendee === null || attendee === void 0 ? void 0 : attendee.status) === "Cancelled" || (communityData === null || communityData === void 0 ? void 0 : communityData.changesAreBlocked),
                }, validationSchema: communitySchema, useUnsavedPrompt: false }, { children: function (_a) {
                    var formikContext = _a.formikContext;
                    return (_jsx(_Fragment, { children: _jsxs(WidgetFieldset, __assign({ isDisabled: (attendee === null || attendee === void 0 ? void 0 : attendee.status) === "Cancelled" || (attendee === null || attendee === void 0 ? void 0 : attendee.changesAreBlocked) }, { children: [_jsx(FormikContextListener, { currentPath: path, path: [Constants.Routes.myAttendeeCommunity], formikContext: formikContext, active: true, initialValues: {}, focusDelay: 500 }), _jsx("h5", __assign({ className: "d-flex va-middle uppercase black m-bottom" }, { children: "Change Community" })), _jsx(Form.Field, { label: "Select a Community", component: Form.Input.Select, id: "communityId", name: "communityId", data: communityData.communities.map(function (community) { return ({
                                        label: communityData.communityId === community.id
                                            ? "".concat(community.name, " (Current Community)")
                                            : community.name,
                                        value: community.id,
                                    }); }), autoComplete: "off" })] })) }));
                } }))] }));
};
export default MyAttendeeCommunity;
